export default __webpack_public_path__ + "static/media/ASTEK-VERT-HOR-RVB.724d2f43.png";